<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center" style="border-bottom: solid 1px #E3F2FF;">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <h3 class="bold header_title dark-blue">Changer de profil</h3>
      </div>

      <div class="p-20" style="border-bottom: solid 1px #E3F2FF;">
        <p class="no-margin mb-10 dark-blue bold">Sélectionnez le profil <span class="red">*</span></p>

        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
          <label class="dark-blue gap-10 flex content-end pointer" style="align-items: center;">
            <span class="text-sm">Ressources Humaines</span>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(0)" [textColor]="'#2B2D67'"
              [text]="defineRole(0)" [fitContent]="true"></app-custom-tag>
            <input type="radio" name="profile" value="0" (change)="validateForm()">
          </label>

          <label class="dark-blue gap-10 flex content-end pointer" style="align-items: center;">
            <span class="text-sm">Bureau de vote</span>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(1)" [textColor]="'#2B2D67'"
              [text]="defineRole(1)" [fitContent]="true"></app-custom-tag>
            <input type="radio" name="profile" value="1" (change)="validateForm()">
          </label>

          <label class="dark-blue gap-10 flex content-end pointer" style="align-items: center;">
            <span class="text-sm">Scrutateur</span>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(2)" [textColor]="'#2B2D67'"
              [text]="defineRole(2)" [fitContent]="true"></app-custom-tag>
            <input type="radio" name="profile" value="2" (change)="validateForm()">
          </label>

          <label class="dark-blue gap-10 flex content-end pointer" style="align-items: center;">
            <span class="text-sm">Chef de projet</span>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(3)" [textColor]="'#2B2D67'"
              [text]="defineRole(3)" [fitContent]="true"></app-custom-tag>
            <input type="radio" name="profile" value="3" (change)="validateForm()">
          </label>
        </div>
      </div>

      <div class="p-20" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
        <div>
          <p class="no-margin mb-10 grey no-margin">Nom <br /><span
              class="bold dark-blue">{{contactToUpdate?.lastName}}</span></p>
          <p class="no-margin mb-10 grey no-margin">Prénom <br /><span
              class="bold dark-blue">{{contactToUpdate?.firstName}}</span></p>
          <p class="no-margin grey no-margin">
            Profil actuel<br />
            <span class="bold dark-blue flex gap-10 align-items-center">
              {{defineFullRole(contactToUpdate?.profile || 0)}}
              <app-custom-tag [isValidated]="true"
                [backgroundColor]="getRoleBackgroundColor(contactToUpdate?.profile || 0)" [textColor]="'#2B2D67'"
                [text]="defineRole(contactToUpdate?.profile || 0)" [fitContent]="true"></app-custom-tag>
            </span>
          </p>
        </div>
        <div>
          <p class="no-margin mb-10 grey no-margin">Email <br /><span
              class="bold dark-blue">{{contactToUpdate?.email}}</span></p>
          <p class="no-margin mb-10 grey no-margin">Invitation <br /><span
              class="bold dark-blue">{{contactToUpdate?.sendInvitation ? 'Oui' : 'Non'}}</span></p>
        </div>
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;" class="p-20">
        <v8te-active-button [buttonText]="'Annuler'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="100" [bold]="true"></v8te-active-button>

        <v8te-active-button [buttonText]="'Changer le profil'" [primaryColor]="'#1990FF'" [textPrimaryColor]="'#FFFFFF'"
          (click)="isFormValid && confirmChangeProfile()" [height]="50" [minWidth]="190" [active]="isFormValid"
          [cursor]="isFormValid ? 'pointer' : 'not-allowed'" [widthPercent]="100" [bold]="true"
          [active]="isFormValid"></v8te-active-button>
      </div>
    </div>
  </div>
</div>